import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = {
  deletedUserIds: [],
}

export default handleActions<
  {
    deletedUserIds: number[]
  },
  any
>(
  {
    [rawActions.getDeletedUserIdsWithAnsweredQuestions.success.toString()]: (state, action) => {
      return {
        ...state,
        deletedUserIds: (action as ReturnType<typeof rawActions.getDeletedUserIdsWithAnsweredQuestions.success>)
          .response.data,
      }
    },
  },
  defaultState
)
